import { useState, useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// router
import { useLocation } from 'react-router-dom'
// library
import dayjs from '../utils/dayjs-config'
// services
import AuditServices from '../services/audit'
// constants
import storageNames from '../constants/storageNames'
// components

const format = 'YYYY/MM/DD'
const currentDate = dayjs().format(format)
let isSending = false

export default function useAudit() {
	// redux
	const {
		session: { userWithoutLogin, email, isLogin, userId }
	} = useSelector(state => state)

	// location
	const { pathname } = useLocation()
	const isParQPublic = pathname.includes('par-q-public')

	// states
	const [auditState, setAuditState] = useState({
		events: localStorage.getItem(storageNames.auditEvents)
			? JSON.parse(localStorage.getItem(storageNames.auditEvents))
			: {},
		currentDate: localStorage.getItem(storageNames.auditEventsDate) || ''
	})

	// actions states
	const setEvents = data => {
		if (!data || data.length === 0) return

		const filtered = Object.values(data).map(e => e.eventName)
		localStorage.setItem(storageNames.auditEvents, JSON.stringify(filtered))
		setAuditState({
			...auditState,
			events: filtered,
			currentDate: currentDate
		})
	}

	// actions
	const getEvents = () => {
		if (isLogin && !isSending) {
			isSending = true
			AuditServices.getEvent()
				.then(res => {
					if (res.status === 200) {
						setEvents(res.data)
						localStorage.setItem(storageNames.auditEventsDate, currentDate)
					}
				})
				.catch(() => null)
				.finally(() => (isSending = false))
		}
	}

	const validEmail = ({ loginEmail, noEmail }) => {
		if (noEmail) return null
		if (loginEmail) return loginEmail

		if (userWithoutLogin && isLogin) return email

		return null
	}

	const handledSaveEventRegistry = ({
		eventName = auditState.events[0],
		trackTime = false,
		caller = null,
		timeSpent,
		loginEmail = null,
		noEmail = false,
		idUser = null
	}) => {
		const payload = {
			email: validEmail({ loginEmail, noEmail }),
			eventName: eventName,
			trackTime: trackTime,
			timeSpent: timeSpent,
			caller: caller
		}
		AuditServices.saveEventRegistry({ userId: idUser ?? userId, payload })
	}

	useEffect(() => {
		if (auditState.events.length > 0 && auditState.currentDate === currentDate) return
		if (isParQPublic) return
		getEvents()
	}, [])

	const actions = {
		handledSaveEventRegistry
	}

	return {
		...auditState,
		...actions
	}
}
